$(document).ready(function() {
    if ($('form.listing-form').length > 0 || $('form.registration-form').length > 0) {
        listingForm.initiate();
    }
});

var listingForm = {
    initiate: function() {
        $('select.parent-category').on('change', this.parentCategorySelected);
        $('select.child-category').on('change', this.childCategorySelected);

        $('input[name="specialities[]"]').on('change', function() {
            if ($('input[name="specialities[]"]:checked').length > 5) {
                $(this).prop('checked', false);
            }
        });

        if ($('form.registration-form').length > 0) {
            this.parentCategorySelected();
        } else {
            this.parentCategorySelected(false);
        }
    },
    parentCategorySelected: function(resetValue = true) {
        var parentCategoryId = $('select.parent-category').find(":selected").val();

        $.get('/api/categories/childs/' + parentCategoryId, function(categories) {
            $('select.child-category option').hide();
            categories.forEach(function(category) {
                $('select.child-category option[value="' + category.id + '"]').show();
            });

            if (resetValue) {
                $('select.child-category option:selected').removeAttr("selected");
                $("select.child-category").val('').trigger("chosen:updated");
            }
        });
    },
    childCategorySelected: function() {}
};
